import { render, staticRenderFns } from "./BuildingsList.vue?vue&type=template&id=6ee33258&scoped=true"
import script from "./BuildingsList.vue?vue&type=script&lang=js"
export * from "./BuildingsList.vue?vue&type=script&lang=js"
import style0 from "./BuildingsList.vue?vue&type=style&index=0&id=6ee33258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee33258",
  null
  
)

export default component.exports